import styled from 'styled-components'

export const OffersAndNewsContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 40px;
`

export const DescriptionSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
